import { ModelEvent } from 'src/broadcast/Events';
import { NotificationBroadcast } from './NotificationCreatedEvent.types';

class NotificationCreatedEvent extends ModelEvent<NotificationBroadcast> {
  public namespace = '.Illuminate\\Notifications\\Events\\BroadcastNotificationCreated';
}

export default NotificationCreatedEvent;
